import {
  DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_BEGIN,
  DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_SUCCESS,
  DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_FAILURE,
  DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
export function createCollectionfromSupabase(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_BEGIN,
    });
    const { projectId, version } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/supabase/create-collection-supabase`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_SUCCESS,
            data: res,
          });
          Mixpanel.track('Created Collection', {
            uuid: res.data.uuid,
            colletionName: res.data.colletionName,
          });
          toast.success('Collection Created Successfully !');
          console.log('collection stored done', res);
          resolve(res);
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          Mixpanel.track('Failed to creat collection');
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionfromSupabaseError() {
  return {
    type: DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_BEGIN:
      return {
        ...state,
        createCollectionfromSupabasePending: true,
        createCollectionfromSupabaseError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_SUCCESS:
      return {
        ...state,
        createCollectionfromSupabasePending: false,
        createCollectionfromSupabaseError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_FAILURE:
      return {
        ...state,
        createCollectionfromSupabasePending: false,
        createCollectionfromSupabaseError: action.data.error,
      };

    case DATA_CONNECTOR_CREATE_COLLECTIONFROM_SUPABASE_DISMISS_ERROR:
      return {
        ...state,
        createCollectionfromSupabaseError: null,
      };

    default:
      return state;
  }
}
